import type { PageInfoFragment } from '@shared/types/storefront/graphql'

export const toCursorPagination = (
  pagination: PageInfoFragment & {
    totalCount?: number
  }
) => {
  return {
    endCursor: pagination.endCursor ?? undefined,
    hasNextPage: pagination.hasNextPage,
    hasPreviousPage: pagination.hasPreviousPage,
    startCursor: pagination.startCursor ?? undefined,
    total: pagination.totalCount,
  }
}
